import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

interface AdminEmailSearch {
  /** Open editor: `?tpl=new` (create) or `?tpl=<id>` (edit). */
  tpl?: string;
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  validateSearch: (search: Record<string, unknown>): AdminEmailSearch => {
    const tpl = typeof search.tpl === "string" && search.tpl.trim() !== "" ? search.tpl : undefined;
    return tpl ? { tpl } : {};
  },
  component: AdminEmailPage,
});
